import "../scss/index.scss";

import './pages/product.js';
// JS Global Sections

import "./sections/multiple-collections";
import "./snippets/product-variant-picker-block";
import "./snippets/lbc-rating-block";
import "./snippets/lbc-product-description";
import "./snippets/lbc-media";
import "./snippets/lbc-avis-garantis.js";
import "./sections/section-page-header.js";
import "./sections/section-newsletter-v2.js";
import "./snippets/lbc-bubble-card.js";

import LazyLoad from "vanilla-lazyload";
// Init Lazy load
var lazyLoadInstance = new LazyLoad();

// responsive images
const responsiveImages = document.querySelectorAll("[data-src-desktop]");

const initResponsiveImages = () => {
  responsiveImages.forEach((img) => {
    const srcDesktop = img.getAttribute("data-src-desktop");
    const srcMobile = img.getAttribute("data-src-mobile");

    const src = window.innerWidth > 768 ? srcDesktop : srcMobile;

    img.src = src;
    img.setAttribute("data-loaded", "true");
  });
};

initResponsiveImages();
window.addEventListener("resize", initResponsiveImages);
